import React from "react";

const IconBag = ({ color = "#333", width = "17", height = "20" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1.61301C6.82342 1.61301 5.46429 2.98504 5.46429 4.67753V5.29043H11.5357V4.67753C11.5357 2.98504 10.1766 1.61301 8.5 1.61301ZM12.75 5.29043V4.67753C12.75 2.30805 10.8472 0.387207 8.5 0.387207C6.15279 0.387207 4.25 2.30805 4.25 4.67753V5.29043H0V17.5485C0 18.9025 1.08731 20.0001 2.42857 20.0001H14.5714C15.9127 20.0001 17 18.9025 17 17.5485V5.29043H12.75ZM1.21429 6.51624V17.5485C1.21429 18.2255 1.75794 18.7743 2.42857 18.7743H14.5714C15.2421 18.7743 15.7857 18.2255 15.7857 17.5485V6.51624H1.21429Z"
        fill={color}
      />
    </svg>
  );
};

export default IconBag;
